import { Alert } from "@platform/design-system";
import { useState } from "react";

export interface UnmappedPlansBannerProps {
  /** Distinct carrier names with unmapped plans across all coverages. */
  carrierNames: string[];
}

/**
 * Dismissible info banner (btx-unmapped-plans) shown above the Quotes grid
 * when any coverage has carrier plan groups that couldn't be auto-mapped.
 */
export const UnmappedPlansBanner = ({
  carrierNames,
}: UnmappedPlansBannerProps): React.JSX.Element | null => {
  const [open, setOpen] = useState<boolean>(true);

  if (!open) {
    return null;
  }

  return (
    <Alert severity="warning" variant="outlined" onClose={() => setOpen(false)}>
      Some quoted plans received in proposal(s) from{" "}
      <strong>{carrierNames.join(", ")}</strong> were not able to be
      auto-mapped. Please review the &apos;Unmapped Plans&apos; LOC page(s) to
      map them to the correct Plan Comparison page(s).
    </Alert>
  );
};
